export default __webpack_public_path__ + "static/media/question.c4378e94.svg";